import { actionCreator } from '@ardoq/rxbeach';
import { OpenDialogPayload } from './types';
import { Trackable } from 'tracking/trackingData';

const openDialog = actionCreator<Trackable<OpenDialogPayload>>(
  '[OrgAdminsList] open dialog'
);
const closeDialog = actionCreator('[OrgAdminsList] close dialog');

export const orgAdminsListActions = {
  openDialog,
  closeDialog,
};
